import React from "react";
import { Heart, Trophy, Zap } from "lucide-react";
import { ASSETS } from "@/lib/assets";

const MeetFifi = () => {
  return (
    <section
      id="meet-fifi"
      data-testid="meet-fifi-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-flex items-center gap-2 rounded-full bg-[#FCE7F3] px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-[#9D174D]">
            <Heart size={14} /> Meet Fifi
          </span>
          <h2 className="font-display mt-5 text-4xl sm:text-5xl font-black tracking-tighter text-slate-900">
            Your <span className="brand-gradient-text">Quant Cat Advisor</span>
            <br />
            grows with every trade.
          </h2>
          <p className="mt-5 text-lg text-slate-600 leading-relaxed">
            Fifi feels what you feel. Win and she cheers. Lose and she cries.
            Complete missions, earn XP, unlock outfits, and level your avatar
            into a fully customized quant pro.
          </p>
        </div>

        {/* Emotion cards grid - centered with max width */}
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto">
          {/* Happy state */}
          <div
            data-testid="emotion-card-up"
            className="relative rounded-3xl overflow-hidden bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-8 group"
          >
            <div className="absolute -top-10 -right-10 w-60 h-60 bg-gradient-to-br from-[#A7F3D0] to-[#34D399] rounded-full blur-3xl opacity-30" />
            <div className="relative flex items-start justify-between gap-6">
              <div className="flex-1">
                <span className="inline-flex items-center gap-1 rounded-full bg-[#D1FAE5] text-[#065F46] px-3 py-0.5 text-xs font-bold">
                  <Zap size={12} /> +3.05%
                </span>
                <h3 className="font-display mt-4 text-2xl font-black text-slate-900 leading-tight">
                  Nice! Your holding is up
                </h3>
                <p className="mt-3 text-slate-600">
                  Fifi celebrates your wins with you. Watch her dance through
                  green candles and remind you why discipline pays.
                </p>
              </div>
              <div className="w-32 sm:w-40 shrink-0 transition-transform group-hover:-translate-y-1 group-hover:rotate-3 duration-300">
                <img
                  src={ASSETS.fifiCheer}
                  alt="Fifi waving cheerfully"
                  width={1000}
                  height={1000}
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>

          {/* Sad state */}
          <div
            data-testid="emotion-card-down"
            className="relative rounded-3xl overflow-hidden bg-white border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-8 group"
          >
            <div className="absolute -top-10 -right-10 w-60 h-60 bg-gradient-to-br from-[#FBCFE8] to-[#F472B6] rounded-full blur-3xl opacity-25" />
            <div className="relative flex items-start justify-between gap-6">
              <div className="flex-1">
                <span className="inline-flex items-center gap-1 rounded-full bg-[#FCE7F3] text-[#9D174D] px-3 py-0.5 text-xs font-bold">
                  −5.43%
                </span>
                <h3 className="font-display mt-4 text-2xl font-black text-slate-900 leading-tight">
                  Oh no, your holding is down
                </h3>
                <p className="mt-3 text-slate-600">
                  Fifi cries with you, then teaches the lesson — risk sizing,
                  stop loss, and when to hold. No shame, just learning.
                </p>
              </div>
              <div className="w-32 sm:w-40 shrink-0 transition-transform group-hover:-translate-y-1 group-hover:-rotate-3 duration-300">
                <img
                  src={ASSETS.fifiSad}
                  alt="Fifi crying"
                  width={1000}
                  height={1000}
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Stats strip */}
        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto">
          {[
            { kpi: "6", label: "Tiers to unlock" },
            { kpi: "Daily", label: "Missions & streaks" },
            { kpi: "6", label: "AI quant features" },
            { kpi: "0$", label: "To start simulating" },
          ].map((s) => (
            <div
              key={s.label}
              data-testid={`fifi-kpi-${s.label.split(" ")[0].toLowerCase()}`}
              className="rounded-2xl bg-white p-5 border border-slate-100 text-center"
            >
              <div className="font-display text-3xl font-black brand-gradient-text">
                {s.kpi}
              </div>
              <div className="text-xs uppercase tracking-[0.15em] font-bold text-slate-500 mt-1">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MeetFifi;
